module.exports = __webpack_public_path__ + "static/media/hero-image-02.1ba53c5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hero-image-02.svg
// module id = 28
// module chunks = 0